var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".youtube_svg__st0{fill:#da2724}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "youtube_svg__st0",
    d: "M88,100H12c-6.6,0-12-5.4-12-12V12C0,5.4,5.4,0,12,0h76c6.6,0,12,5.4,12,12v76C100,94.6,94.6,100,88,100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2,70.3c-15.5,0.9-30.9,0.9-46.4,0c-2.6-0.2-5.1-2.5-5.4-5.1c-1.1-10.1-1.1-20.3,0-30.4 c0.3-2.6,2.8-4.9,5.4-5.1c15.5-0.9,30.9-0.9,46.4,0c2.6,0.2,5.1,2.5,5.4,5.1c1.1,10.1,1.1,20.3,0,30.4 C78.3,67.8,75.8,70.1,73.2,70.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube_svg__st0",
    d: "M43.3 41.1L59.1 49.3 43.3 57.6z"
  }))));
}

export default SvgYoutube;